<script lang="ts">
    import {createEventDispatcher} from 'svelte';

    export let options = []
    export let value;
    export let title;
    let inputEl;


    const dispatch = createEventDispatcher();

    function updateValue() {
        dispatch('configValueChanged', value);
    }

</script>

<div style="width: 100%" class="flex flex-row bg-center pt-1 w-fit form-control no-animation">
    <label class="basis-1/3 text-input-label">{title}: </label>
    <select class="select select-sm" bind:value={value} on:change={updateValue}>
        {#if options.length === 0}
            <option disabled>No options found</option>
        {/if}
        {#each options as option (option)}
            <option value={option}>{option}</option>
        {/each}
    </select>
</div>
